import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

const Pill = ({
  text = "",
  className = "",
  type = "primary",
  onClick = () => {},
}) => {
  // /icons/warning-alert.svg
  const [pillAttributes, setPillAttributes] = useState({});

  const pillAttributesFunction = (_key) => {
    switch (_key) {
      case "primary":
        return setPillAttributes({ iconColor: "bg-REELTeal" });
        break;
      case "danger":
        return setPillAttributes({ iconColor: "bg-red-300" });
        break;
      case "pink":
        return setPillAttributes({ iconColor: "bg-pink" });
        break;
      default:
        break;
    }
  };

  const pillColor = (_key) => {
    switch (_key) {
      case "primary":
        return `bg-REELTeal/20 text-REELTeal border-REELTeal`;
        break;
      case "danger":
        return `text-red-300 border-red-300`;
        break;
      case "pink":
        return `bg-pink/20 text-pink border-pink`;
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    pillAttributesFunction(type);
  }, [type]);

  return (
    <div
      className={`flex items-center text-[10px] border rounded-full overflow-hidden ${pillColor(
        type
      )} ${className}`}
      onClick={onClick}
    >
      {/* {iconUrl && ( */}
      <span
        className={`pl-1.5 pr-1 py-0.5 h-full flex items-center ${pillAttributes.iconColor}`}
      >
        {/* <ReactSVG src={iconUrl} aria-hidden="true" className="w-3 h-3" /> */}
        <ExclamationTriangleIcon
          className="w-3 h-3 text-white"
          aria-hidden="true"
        />
      </span>
      {/* )} */}
      <span className={`py-0.5 pr-2 pl-1 font-semibold leading-[12px]`}>
        {text}
      </span>
    </div>
  );
};

export default Pill;
